import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Footer from "./Footer";
import { isLoggedIn } from "../utils/auth";
import "./LegalPageLayout.css";

function LegalPageLayout({ title, children }) {

    const loggedIn = isLoggedIn();

    return (

        <div className="legal-page">

            <div className="legal-page-header">

                <Link to={loggedIn ? "/dashboard" : "/"} className="legal-back-link">
                    <FaArrowLeft /> {loggedIn ? "Back to Dashboard" : "Back to Login"}
                </Link>

                <span className="legal-copyright-line">
                    &copy; 2026 Kinetiq Robotics Private Limited (KRPL). All rights reserved.
                </span>

            </div>

            <div className="legal-page-body">

                <div className="legal-page-card">

                    <h1>{title}</h1>

                    {children}

                </div>

            </div>

            <Footer />

        </div>

    );

}

export default LegalPageLayout;
